import React from 'react'
import { MessageSquare } from 'lucide-react'
import { Button } from '@/components/ui/button'
import store from '../../../state/store'

class SmsButton extends React.Component {

  onClick = () => {
    store.emit('ui:enquiry:smser:toggle')
  }

  render() {
    return (
      <Button size="sm" variant="secondary" title="Send SMS" onClick={this.onClick}><MessageSquare className="size-4" /></Button>
    )
  }
}

export default SmsButton
